var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_522_17820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6016 15.183L18.4544 9.227C17.6875 8.59045 16.5001 9.12277 16.5001 10.1427V22.0547C16.5001 23.0747 17.6875 23.6107 18.4544 22.9705L25.6016 17.0145C26.1711 16.538 26.1711 15.6595 25.6016 15.183ZM16.072 15.183L8.92477 9.227C8.15794 8.59045 6.97046 9.12277 6.97046 10.1427V22.0547C6.97046 23.0747 8.15794 23.6107 8.92477 22.9705L16.072 17.0145C16.6415 16.538 16.6415 15.6595 16.072 15.183Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_522_17820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.0592,
    height: 19.0592,
    fill: "white",
    transform: "translate(6.97046 6.56885)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.33439728d1b18742c6352982e73c3589.svg";
export { ForwardRef as ReactComponent };